export default "__VITE_ASSET__DjEXHioc__"